
import React, { Component, PureComponent } from 'react'
import ReactDOM from 'react-dom'
import {
  Link,
  Switch,
  Redirect
} from 'react-router-dom'

import { connect } from 'react-redux'
import { CurrentStepSetAction } from '../../actions/action'
import CONSTANTS from '../../constants'
import Icon from '../buttons/Icon'
import BreadcrumbItem from './BreadcrumbItem'
import ConfirmationDialog from './ConfirmationDialog'
import { isExistPrestationWithForfait, slugify } from '../../helpers/functions'
import { Button } from "../Forms/Forms";

import './Breadcrumb.css'

const mapStateToProps = state => state
const mapDispatchToProps = { CurrentStepSetAction }

class Breadcrumb extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedStep: this.props.store.step,
      stepDialogVisible: 0,
      showDialog: false,
      redirectToPage: false

    }
    this.setClickedStep = this.setClickedStep.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedStep: nextProps.store.step
    })
  }

  setClickedStep(step) {
    this.setState({ selectedStep: step })
    this.props.CurrentStepSetAction(step)
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.redirectToPage) { this.setState({ redirectToPage: false }) }
  }

  render() {
    const breadcrumbData = [{
      title: CONSTANTS.LABELS.header_ariane1,
      link: CONSTANTS.SITE_ROUTS.HOMEPAGE,
      stepNumber: 1,
      isEnabled: (!this.props.store.isEditMode),
      eventLabel: 'crumbtrail_search'
    }, {
      title: CONSTANTS.LABELS.header_ariane2,
      link: (Object.values(this.props.store.dealer).length
        ? (CONSTANTS.SITE_ROUTS.SOLODEALERPAGE + slugify(this.props.store.dealer.city) + '/' + slugify(this.props.store.dealer.name) + '/' + this.props.store.dealer.geoID)
        : CONSTANTS.SITE_ROUTS.HOMEPAGE),
      stepNumber: 2,
      isEnabled: true,
      eventLabel: 'crumbtrail_appointment'
    }, {
      title: CONSTANTS.LABELS.header_ariane3,
      link: CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE,
      stepNumber: 3,
      isEnabled: true,
      eventLabel: 'crumbtrail_vehicule'
    }, {
      title: CONSTANTS.LABELS.header_ariane4,
      link: CONSTANTS.SITE_ROUTS.SERVICESPAGE,
      stepNumber: 4,
      isEnabled: true,
      eventLabel: 'crumbtrail_operations'
    }, {
      title: CONSTANTS.LABELS.header_ariane5,
      link: CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE,
      stepNumber: 5,
      isEnabled: true,
      eventLabel: 'crumbtrail_infos'
    }, {
      title: CONSTANTS.LABELS.header_ariane6,
      link: CONSTANTS.SITE_ROUTS.SUMMARYPAGE,
      stepNumber: 6,
      isEnabled: true,
      eventLabel: 'crumbtrail_summary'
    }]

    return (
      <nav className='breadcrumb' role='navigation' aria-label='Main navigation'>
        <ol className='container-standard-content'>
          {window.isMobile() == 'desktop' && CONSTANTS.SITE_INFO.BRAND_CODE == "D" && Object.values(breadcrumbData).map(function (data, key) {
            if (data.stepNumber == this.state.selectedStep) {
              return (
                <React.Fragment key={`return-${key}`}>
                  {this.state.redirectToPage && key > 0 && <Switch>
                    <Redirect
                      key='from-return'
                      push
                      to={CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}
                    />
                  </Switch>}
                  <Button Type="border" Disabled={key == 0} classes="return-btn">
                    {key == 0 && CONSTANTS.LABELS.header_ariane0}

                    {key > 0 && <>
                      {this.state.showDialog && <ConfirmationDialog isConfirmedDialog={(e) => {
                        if (e) {
                          this.setClickedStep(key)
                          this.setState({ redirectToPage: true })
                        }
                        this.setState({ showDialog: false })
                      }}
                      />}
                      {key == 3 &&
                        <span
                          Name='arrowNavBold-reverse' onClick={() => {
                            if (isExistPrestationWithForfait(this.props.store.SelectedServices)) { this.setState({ showDialog: true }) } else {
                              this.setClickedStep(key)
                              this.setState({ redirectToPage: true })
                            }
                          }}
                        >{CONSTANTS.LABELS.header_ariane0}</span>}
                      {
                        key > 0 && key != 3 && <Link
                          to={Object.values(breadcrumbData)[key - 1].link}
                          onClick={() => {
                            this.setClickedStep(key)
                          }}
                        >
                          {CONSTANTS.LABELS.header_ariane0}
                        </Link>}
                    </>}

                  </Button>
                </React.Fragment>
              )
            }
          }.bind(this))
          }

          {Object.values(breadcrumbData).map(function (data, key) {
            // if desktop then render this or brand citroen and mobile
            if (window.isMobile() == 'desktop' || (CONSTANTS.SITE_INFO.BRAND_CODE === "C" && window.isMobile() == 'mobile')) {
              return (
                <BreadcrumbItem
                  key={`breadcrumb-${key}`}
                  {...data}
                  stepNumber={data.stepNumber}
                  setStepDialogVisible={(num) => this.setState({ stepDialogVisible: num })}
                  stepDialogVisible={this.state.stepDialogVisible}
                  currentStep={this.state.selectedStep}
                  onClick={() => this.setClickedStep(data.stepNumber)}
                  brand={CONSTANTS.SITE_INFO.BRAND_CODE}
                  totalSteps={breadcrumbData.length}
                />
              )
            }
            // if mobile then render this part
            else if (data.stepNumber == this.state.selectedStep) {
              return (<React.Fragment key={`breadcrumb-${key}`}>
                {this.state.redirectToPage && key > 0 && <Switch>
                  <Redirect
                    key='from-breadcrumb'
                    push
                    to={CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}
                  />
                </Switch>}
                <li className={`prev-icon  key-${key}`}>
                  {key == 0 &&
                    <Icon Name='arrowNavBold-reverse' />}
                  {key > 0 && <>
                    {this.state.showDialog && <ConfirmationDialog isConfirmedDialog={(e) => {
                      if (e) {
                        this.setClickedStep(key)
                        this.setState({ redirectToPage: true })
                      }
                      this.setState({ showDialog: false })
                    }}
                    />}
                    {key == 3 &&
                      <Icon
                        Name='arrowNavBold-reverse' onClick={() => {
                          if (isExistPrestationWithForfait(this.props.store.SelectedServices)) { this.setState({ showDialog: true }) } else {
                            this.setClickedStep(key)
                            this.setState({ redirectToPage: true })
                          }
                        }}
                      />}
                    {
                      key > 0 && key != 3 && <Link
                        to={Object.values(breadcrumbData)[key - 1].link}
                        onClick={() => {
                          this.setClickedStep(key)
                        }}
                      >
                        <Icon Name='arrowNavBold-reverse' />
                      </Link>}
                  </>}

                </li>
                <li className='main-title'>
                  {CONSTANTS.SITE_INFO.BRAND_CODE === 'P' && <i className={`mark-icons ${data.eventLabel}`}></i>}
                  <div style={{ lineHeight: '36px' }}>
                    <span className='step-title'>{data.title}</span>
                  </div>
                </li>
                <li className='next-icon'><Icon Name='arrowNavBold' /></li>
              </React.Fragment>)
            }
          }.bind(this))}

        </ol>
      </nav>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumb)
